import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-p2-off-duty-datas',
  templateUrl: './p2-off-duty-datas.component.html',
  styleUrls: ['./p2-off-duty-datas.component.css']
})
export class P2OffDutyDatasComponent implements OnInit {
    public setting?: Setting;

    public selectListLabours: Item[] = [];

    public itemsListOffDutyDatas: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {

    }

    private async loadSetting() {
        this.setting = (await this.datatask.Post(572))[0];
    }

    private async loadLabours(): Promise<void> {
        this.selectListLabours = await this.datatask.Post(101, { activestatus: 'ACT' });
    }

    private async loadOffDutyDatas(): Promise<void> {
        if (!!this.setting) {
            this.itemsListOffDutyDatas = await this.datatask.Post(573, { labour_no: this.setting?.labour_no });
        }
    }

    public onChanged(_: string, id: keyof Setting) {
        switch (id) {
            case 'labour_no':
                this.loadOffDutyDatas();
                break;
            default:
                break;
        }
    }

    public goToFunc(state: any) {
        switch (state) {
            case 'p2offdutydata':
                this.stateService?.go('p2offdutydata', {
                    p2_offdutydata_keyno: '0',
                    labour_no: this.setting?.labour_no
                });
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadLabours();
        this.loadOffDutyDatas();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    labour_no: string;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('p2OffDutyDatas', {
//        templateUrl: 'views/components/views/p2OffDutyDatas/p2OffDutyDatas.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$q', 'stateService', 'utilityService', 'p2OffDutyDatasService', 'economyService', function ($q, stateService, utilityService, p2OffDutyDatasService, economyService) {
//            const vm = this;

//            vm.model = {
//                setting: {},
//                selectListLabours: [],
//                itemsListOffDutyDatas: []
//            };

//            let loadSetting = function () {
//                const deferred = $q.defer();

//                p2OffDutyDatasService.getSetting().then(function (info) {
//                    angular.copy(info[0], vm.model.setting);

//                    $q.all([
//                        loadOffDutyDatas()
//                    ]).then(() => deferred.resolve());
//                });

//                return deferred.promise;
//            };

//            let loadLabours = function () {
//                economyService.listLabours({ activestatus: 'ACT' }).then(function (list) {
//                    angular.copy(list, vm.model.selectListLabours);
//                });
//            };

//            let loadOffDutyDatas = function () {
//                if (utilityService.validateParmsValue(vm.model.setting.labour_no) !== true) return;

//                return p2OffDutyDatasService.listOffDutyDatas({ labour_no: vm.model.setting.labour_no }).then(function (list) {
//                    angular.copy(list, vm.model.itemsListOffDutyDatas);
//                });
//            };

//            vm.goToFunc = function (state, e) {
//                let go = function (parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                };

//                switch (state) {
//                    case 'p2offdutydata':
//                        go({
//                            p2_offdutydata_keyno: '0',
//                            labour_no: vm.model.setting.labour_no
//                        });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            vm.onChanged = function (value, id) {
//                switch (id) {
//                    case 'labour_no':
//                        if (utilityService.validateWatchValue(value, vm.model.setting.labour_no) !== true) return;

//                        vm.model.setting.labour_no = value;

//                        if (utilityService.validateParmsValue(vm.model.setting.labour_no) !== true) return;

//                        loadOffDutyDatas();
//                        break;
//                    default:
//                        utilityService.setValueToVariable(value);
//                        break;
//                }
//            };

//            vm.$onInit = function () {
//                loadSetting();
//                loadLabours();
//            };
//        }]
//    });
//})();
